module.exports = __webpack_public_path__ + "img/kewalcare.caa04673.png";